<div #videoPresentationParent class="video-player-presentation {{ activeView() }}"
     [class.paused]="!!video?.paused" [class.sync-view]="syncView()">
    @if (slides()?.length && !syncView() && activeView() != null) {
        <div class="top-right-corner">
            <app-video-view-picker (activeViewChange)="this.activeView.set($event)" [currentView]="activeView()!" />
        </div>
    }
    <div class="video-parent">
        <video #video (timeupdate)="currentSeconds.set(video.currentTime)" playsinline (canplay)="onBufferChange()"
               (progress)="onBufferChange()" [volume]="this.volume() / 100" (click)="toggleVideoPlayPause($event)"
               (loadeddata)="onLoad()" crossorigin="anonymous" preload="metadata" autoplay>
            <source type="video/mp4" [src]="videoPart().video_url!">
            @for (st of videoPart().subtitles; track st.id) {
                <track kind="captions" [id]="st.id" [label]="st.language" [srclang]="st.language" [src]="st.url" />
            }
        </video>

        @if (!currentSeconds() && videoPart().thumbnail) {
            <img [src]="videoPart().thumbnail" class="thumbnail" alt="video thumbnail"
                 loading="eager" (click)="toggleVideoPlayPause($event)" />
        }
    </div>
    @if (activeView() != VideoView.Video) {
        <div class="presentation" (click)="toggleVideoPlayPause($event)">
            <img [src]="currentSlideImg()" alt="slide-image" loading="eager" />
        </div>
    }
    <div class="video-controls-container">
        <div class="timeline-container">
            <div class="timeline" #timeline (click)="onChangeTimeline($event)">
                <div class="thumb-indicator" #thumbIndicator></div>
                <div class="timeline-buffered" #timelineBuffered></div>
                @if (slides()?.length && this.video) {
                    <app-timeline-slides [slides]="slides()!" [durationSec]="this.video!.duration" />
                }
            </div>
        </div>
        <div class="controls">
            <div class="left">
                <fa-icon [icon]="video?.paused ? faPlay : faPause" (click)="toggleVideoPlayPause($event)"
                         [title]="video?.paused ? 'Play' : 'Pause'"
                />
                <div class="volume">
                    <fa-icon [icon]="video?.volume ? faVolumeUp : faVolumeMute" (click)="toggleVolume()"
                             [title]="video?.volume ? 'Mute' : 'Unmute'"
                    />
                    <input class="volume-slider" type="range" min="0" max="100" step="1" value="1"
                           name="volumeRange" [(ngModel)]="volume" title="Volume" />
                </div>
                @if (video.duration) {
                    <div class="duration">
                        {{ video.currentTime | secondsToTimestamp }} / {{ video.duration | secondsToTimestamp }}
                    </div>
                }
                @if (isVideoLoaded()) {
                    <div class="timechange-controls">
                        <fa-icon [icon]="faBackward" (click)="onBackward()" title="Backward" />
                        <fa-icon [icon]="faForward" (click)="onForward()" title="Forward" />
                    </div>
                }
            </div>
            <div class="right">
                <app-video-subtitles-picker [subtitles]="videoPart().subtitles" (onChange)="onSubtitleChange($event)" />
                <app-video-player-speeds (onVideoSpeedClick)="onVideoSpeedClick($event)" />
                <fa-icon [icon]="isFullScreenMode() ? faCompress : faExpand" (click)="toggleFullScreen()"
                         [title]="isFullScreenMode() ? 'Exit full screen' : 'Full screen'"
                />
            </div>
        </div>
    </div>
    @if (!isVideoLoaded()) {
        <app-spinner class="spinner" />
    }
</div>
